import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { IOnboardingEditItem } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import {
    IOnboardingAssigneesItem,
    IOnboardingAssigneesSave,
} from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized';

@Injectable()
export class FiOnboardingSynchronizedService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    /*getOnboardingAssignees() {
        return this.fiBackend.fetchData<IOnboardingAssigneesItem[]>(
            `Onboarding/OnboardingSynchronized/GetOnboardingAssignees`,
        );
    }*/

    getOnboardingAssigneesItem(onboardingId: number) {
        return this.fiBackend.fetchData<IOnboardingAssigneesItem>(
            `Onboarding/OnboardingSynchronized/GetOnboardingAssigneesItem/${onboardingId}`,
        );
    }

    saveOnboardingAssignees(dataForSave: IOnboardingAssigneesSave) {
        const promise = this.fiBackend.fetchDataPost<void>(
            `Onboarding/OnboardingSynchronized/SaveOnboardingAssignees`,
            dataForSave,
        );
        return this.fiLoading.trackPromise(promise);
    }
}
